import { createStyles } from "@mantine/emotion";

export const useStylesUserFound = createStyles((theme) => ({
  textKey: {
    fontSize: theme.spacing.userFound.fontSize.key,
  },
  textValue: {
    fontSize: theme.spacing.userFound.fontSize.value,
    fontFamily: theme.headings.fontFamily.bold,
    span: {
      fontFamily: theme.headings.fontFamily.light,
    },
  },

  textValueBlockChainAddressFix: {
    overflow: "auto",
    maxWidth: theme.spacing.userFound.maxWidth.blockChainAddress,
  },
  downloadPdf: {
    background: "none",
    border: "none",
  },
}));
